import { FC, useEffect, useState } from "react";
import { Column, ScrollRow } from "../containers";
import { AlignItems, Wrap } from "../containers/types";
import Options from "../options";
import { DateRange } from "../../types";
import { Option } from "../options/types";
import { DATE_RANGE_OPTIONS } from "./data";
import LastFewDays from "./last-few-days";
import { Activity, ActivityRendererType } from "../activity/types";
import ActivityRenderer from "../activity";
import { ActivityApi, DEBUG } from "../../api";

const DateBaseActivities: FC = () => {
  const [selectedOption, setSelectedOption] = useState<Option<DateRange>>(
    DATE_RANGE_OPTIONS[2]
  );

  const onSelectDay = (dr: DateRange): void => {
    setSelectedOption({ title: "custom", value: dr });
  };

  const [activities, setActivities] = useState<Array<Activity>>([]);

  useEffect(() => {
    if (DEBUG) return;
    setActivities([]);
    ActivityApi.getInRange(selectedOption.value)
      .then((acts) => {
        setActivities(acts);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedOption]);

  return (
    <Column style={{ width: "100%" }} alignItems={AlignItems.Start} gap={50}>
      <Options<DateRange>
        options={DATE_RANGE_OPTIONS}
        selectedOption={selectedOption}
        setSelectedOption={setSelectedOption}
      />
      <LastFewDays
        setSelectedDay={onSelectDay}
        selectedDay={selectedOption.value}
      />
      <ScrollRow
        gap={20}
        flexWrap={Wrap.Wrap}
        style={{ width: "100%" }}
        height={300}
      >
        {activities.map((activity, idx) => (
          <ActivityRenderer
            key={idx}
            activity={activity}
            type={ActivityRendererType.Big}
          />
        ))}
      </ScrollRow>
    </Column>
  );
};

export default DateBaseActivities;
